module.exports = __webpack_public_path__ + "img/4.f19d92b2.jpg";